function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get, compact, every, includes, isEmpty, isFunction, isNil, isNull, slice, some } from 'lodash';
import moment from 'moment';
import Icon from "../../Display/Icon";
import { getPreferredProp } from "../utils";
import { maskValue, momentizeValue, convertToUnixTimestamp, validateDate, shouldDisableDay as _shouldDisableDay } from "../../utils/Dates";
import { getPropagationPath } from "../../utils/Browser";
import Calendar from "../Calendar";
var DurationField = /*#__PURE__*/function (_Component) {
  function DurationField(props) {
    var _this;
    _classCallCheck(this, DurationField);
    _this = _callSuper(this, DurationField, [props]);
    _this.onCalendarClick = _this.onCalendarClick.bind(_this);
    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onDaySelect = _this.onDaySelect.bind(_this);
    _this.onPreviousMonth = _this.onPreviousMonth.bind(_this);
    _this.onNextMonth = _this.onNextMonth.bind(_this);
    _this.onEditYear = _this.onEditYear.bind(_this);
    _this.onFakeInputKeyPress = _this.onFakeInputKeyPress.bind(_this);
    _this.getFormatedRange = _this.getFormatedRange.bind(_this);
    _this.isClickOutside = _this.isClickOutside.bind(_this);
    _this.validate = _this.validate.bind(_this);
    var startValue = momentizeValue(getPreferredProp(props, 'value', props.startFieldPath), props.dateFormat, props.isUtc);
    var endValue = momentizeValue(getPreferredProp(props, 'value', props.endFieldPath), props.dateFormat, props.isUtc);
    _this.state = {
      isOpen: false,
      startValue: startValue,
      endValue: endValue,
      startInputValue: null,
      endInputValue: null,
      yearValue: null,
      year: startValue && startValue.isValid() ? startValue.year() : moment().year(),
      month: startValue && startValue.isValid() ? startValue.month() : moment().month()
    };
    return _this;
  }
  _inherits(DurationField, _Component);
  return _createClass(DurationField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
        startFieldPath = _this$props.startFieldPath,
        endFieldPath = _this$props.endFieldPath;
      if (getPreferredProp(this.props, 'value', startFieldPath) !== getPreferredProp(nextProps, 'value', startFieldPath)) {
        var value = momentizeValue(getPreferredProp(nextProps, 'value', startFieldPath), nextProps.dateFormat, nextProps.isUtc);
        this.setState({
          startValue: value,
          year: value ? value.year() : moment().year(),
          month: value ? value.month() : moment().month()
        });
      }
      if (getPreferredProp(this.props, 'value', endFieldPath) !== getPreferredProp(nextProps, 'value', endFieldPath)) {
        var _value = momentizeValue(getPreferredProp(nextProps, 'value', endFieldPath), nextProps.dateFormat, nextProps.isUtc);
        this.setState({
          endValue: _value
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof document === 'undefined') return;
      document.removeEventListener('click', this.isClickOutside);
    }
  }, {
    key: "onCalendarClick",
    value: function onCalendarClick(e) {
      var _this2 = this;
      if (typeof document === 'undefined') return;
      e.preventDefault();
      this.setState({
        isOpen: !this.state.isOpen
      }, function () {
        if (_this2.state.isOpen) {
          document.addEventListener('click', _this2.isClickOutside);
        } else {
          document.removeEventListener('click', _this2.isClickOutside);
        }
      });
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(e, path) {
      var value = get(e, 'target.value', '');
      if (this.props.useMask) {
        value = maskValue(value, this.props.dateFormat);
      }
      this.setState(_defineProperty({}, "".concat(path, "InputValue"), value));
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var startValue = this.state.startValue;
      var endValue = this.state.endValue;
      var _this$props2 = this.props,
        startFieldPath = _this$props2.startFieldPath,
        endFieldPath = _this$props2.endFieldPath;
      if (startValue && endValue && startValue.isAfter(endValue)) {
        startValue = this.state.endValue;
        endValue = this.state.startValue;
      }
      if (this.props.isUtc) {
        startValue = startValue && moment.utc(startValue.format(this.props.dateFormat), this.props.dateFormat);
        endValue = endValue && moment.utc(endValue.format(this.props.dateFormat), this.props.dateFormat);
      }
      if (isFunction(this.props.valueFormat)) {
        getPreferredProp(this.props, 'onChange', startFieldPath)(startValue ? this.props.valueFormat(startValue) : '');
        getPreferredProp(this.props, 'onChange', endFieldPath)(endValue ? this.props.valueFormat(endValue) : '');
      } else {
        getPreferredProp(this.props, 'onChange', startFieldPath)(startValue ? startValue.format(this.props.valueFormat) : '');
        getPreferredProp(this.props, 'onChange', endFieldPath)(endValue ? endValue.format(this.props.valueFormat) : '');
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e, path) {
      if (e.target.value.length < 3) {
        this.setState(_defineProperty({}, "".concat(path, "InputValue"), null));
        return;
      }
      var oldValue = get(this.state, "".concat(path, "InputValue"), null);
      var fieldPath = get(this.props, "".concat(path, "FieldPath"), null);
      if (!isNull(oldValue)) {
        var value = momentizeValue(e.target.value, this.props.dateFormat, this.props.isUtc);
        this.setState(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(path, "InputValue"), null), "".concat(path, "Value"), value), "year", value && value.isValid() ? value.year() : moment().year()), "month", value && value.isValid() ? value.month() : moment().month()), this.onChange);
      }
      if (isFunction(getPreferredProp(this.props, 'onBlur', fieldPath))) {
        getPreferredProp(this.props, 'onBlur', fieldPath)();
      }
    }
  }, {
    key: "onDaySelect",
    value: function onDaySelect(day, secondary) {
      var _this3 = this;
      var value = this.props.isUtc ? day.utc() : day;
      var _this$props3 = this.props,
        startFieldPath = _this$props3.startFieldPath,
        endFieldPath = _this$props3.endFieldPath;
      var startValue = this.state.startValue;
      var endValue = this.state.endValue;
      var stayOpen = true;
      var year = this.state.year;
      var month = this.state.month;
      if (!secondary) {
        year = value && value.isValid() ? value.year() : moment().year();
        month = value && value.isValid() ? value.month() : moment().month();
      }
      if (this.state.startValue && !this.state.endValue) {
        startValue = this.state.startValue;
        endValue = day;
        stayOpen = false;
      } else {
        startValue = day;
        endValue = null;
      }
      this.setState({
        isOpen: stayOpen,
        startValue: startValue,
        endValue: endValue,
        year: year,
        month: month
      }, function () {
        if (!stayOpen) {
          if (typeof document === 'undefined') return;
          if (isFunction(getPreferredProp(_this3.props, 'onBlur', startFieldPath))) {
            getPreferredProp(_this3.props, 'onBlur', startFieldPath)();
          }
          if (isFunction(getPreferredProp(_this3.props, 'onBlur', endFieldPath))) {
            getPreferredProp(_this3.props, 'onBlur', endFieldPath)();
          }
          document.removeEventListener('click', _this3.isClickOutside);
        }
        _this3.onChange();
      });
    }
  }, {
    key: "onPreviousMonth",
    value: function onPreviousMonth() {
      var prev = moment({
        month: this.state.month,
        year: this.state.year
      }).subtract(1, 'month');
      this.setState({
        month: prev.month(),
        year: prev.year()
      });
    }
  }, {
    key: "onNextMonth",
    value: function onNextMonth() {
      var next = moment({
        month: this.state.month,
        year: this.state.year
      }).add(1, 'month');
      this.setState({
        month: next.month(),
        year: next.year()
      });
    }
  }, {
    key: "onEditYear",
    value: function onEditYear(e) {
      var _this4 = this;
      var value = slice(e.target.value, 0, 4).toString().replace(/\D/g, '');
      this.setState({
        yearValue: value
      }, function () {
        if (value && value.length === 4) {
          _this4.setState({
            year: parseInt(value, 10),
            yearValue: null
          });
        }
      });
    }
  }, {
    key: "onFakeInputKeyPress",
    value: function onFakeInputKeyPress(e) {
      e.preventDefault();
      if (e.charCode === 13 || e.charCode === 32) {
        this.onCalendarClick(e);
      }
    }
  }, {
    key: "getFormatedRange",
    value: function getFormatedRange() {
      var dateFormat = this.props.dateFormat;
      var start = this.state.startValue ? this.state.startValue.format(dateFormat) : null;
      var end = this.state.endValue ? this.state.endValue.format(dateFormat) : null;
      var separator = this.state.startValue || this.state.endValue ? this.props.separator : null;
      return compact([start, separator, end]).join(' ');
    }
  }, {
    key: "getInputValue",
    value: function getInputValue(path) {
      var value = get(this.state, "".concat(path, "Value"), null);
      var inputValue = get(this.state, "".concat(path, "InputValue"), null);
      if (isNil(inputValue)) {
        if (value) {
          return value.format(this.props.dateFormat);
        }
        return '';
      }
      return inputValue;
    }
  }, {
    key: "isClickOutside",
    value: function isClickOutside(e) {
      var _this5 = this;
      var _this$props4 = this.props,
        startFieldPath = _this$props4.startFieldPath,
        endFieldPath = _this$props4.endFieldPath;
      if (!includes(getPropagationPath(e), this.element)) {
        if (typeof document === 'undefined') return;
        this.setState({
          isOpen: false
        }, function () {
          if (isFunction(getPreferredProp(_this5.props, 'onBlur', startFieldPath))) {
            getPreferredProp(_this5.props, 'onBlur', startFieldPath)();
          }
          if (isFunction(getPreferredProp(_this5.props, 'onBlur', endFieldPath))) {
            getPreferredProp(_this5.props, 'onBlur', endFieldPath)();
          }
          document.removeEventListener('click', _this5.isClickOutside);
        });
      }
    }
  }, {
    key: "validate",
    value: function validate(value) {
      var _this$props5 = this.props,
        maxDate = _this$props5.maxDate,
        minDate = _this$props5.minDate,
        shouldDisableDate = _this$props5.shouldDisableDate,
        dateFormat = _this$props5.dateFormat,
        isUtc = _this$props5.isUtc;
      var date = momentizeValue(value, dateFormat, isUtc);
      return validateDate(date, maxDate, minDate, shouldDisableDate, dateFormat);
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _this$props6 = this.props,
        className = _this$props6.className,
        labelClassName = _this$props6.labelClassName,
        dateFormat = _this$props6.dateFormat,
        disabled = _this$props6.disabled,
        endField = _this$props6.endField,
        hideLabel = _this$props6.hideLabel,
        hint = _this$props6.hint,
        id = _this$props6.id,
        inline = _this$props6.inline,
        isUtc = _this$props6.isUtc,
        label = _this$props6.label,
        maxDate = _this$props6.maxDate,
        minDate = _this$props6.minDate,
        placeholder = _this$props6.placeholder,
        required = _this$props6.required,
        shouldDisableDate = _this$props6.shouldDisableDate,
        startField = _this$props6.startField,
        style = _this$props6.style,
        name = _this$props6.name,
        startFieldPath = _this$props6.startFieldPath,
        endFieldPath = _this$props6.endFieldPath;
      var fields = [startField, endField];
      var fieldPaths = [startFieldPath, endFieldPath];
      var hasError = every(fields, function (field, index) {
        return getPreferredProp(_this6.props, 'touched', fieldPaths[index]);
      }) && (some(fields, function (field, index) {
        return getPreferredProp(_this6.props, 'invalid', fieldPaths[index]);
      }) || this.state.startValue && !this.state.startValue.isValid() || this.state.endValue && !this.state.endValue.isValid());
      var nextMonth = moment({
        year: this.state.year,
        month: this.state.month
      }).add(1, 'month');
      var containerClass = function containerClass() {
        return classNames({
          'ui-duration-field': true,
          'ui-form-field': true,
          'ui-form-field--inline': inline,
          'ui-form-field--has-error': hasError,
          'ui-form-field--disabled': disabled,
          'ui-duration-field--has-error': hasError,
          'ui-duration-field--droptdown-open': _this6.state.isOpen
        }, className);
      };
      var labelClass = function labelClass() {
        return classNames(_defineProperty(_defineProperty({
          'ui-form-field__label': true,
          'ui-form-field__label--required': required
        }, labelClassName, !isEmpty(labelClassName)), 'sr-only', hideLabel));
      };
      var dropDownClass = function dropDownClass() {
        return classNames({
          'ui-duration-field__dropdown': true,
          'ui-duration-field__dropdown--open': _this6.state.isOpen
        });
      };
      return /*#__PURE__*/React.createElement("div", {
        className: containerClass(),
        style: style.container,
        ref: function ref(c) {
          _this6.element = c;
        }
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: id,
        className: labelClass(),
        style: style.label
      }, label), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        id: id,
        className: "ui-duration-field__fake-input",
        onClick: this.onCalendarClick,
        disabled: disabled,
        onKeyPress: this.onFakeInputKeyPress
      }, this.getFormatedRange()), /*#__PURE__*/React.createElement("div", {
        className: "ui-date-field__calendar-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "IconCalendar",
        disabled: disabled || this.state.startValue && !this.state.startValue.isValid(),
        onClick: this.onCalendarClick
      })), /*#__PURE__*/React.createElement("div", {
        className: dropDownClass(),
        style: style.dropdown
      }, /*#__PURE__*/React.createElement("div", {
        className: "ui-duration-field__inputs"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "".concat(id, "-start"),
        className: "sr-only"
      }, "Start Date"), /*#__PURE__*/React.createElement("input", {
        id: "".concat(id, "-start"),
        value: this.getInputValue('start'),
        onChange: function onChange(e) {
          return _this6.onInputChange(e, 'start');
        },
        onBlur: function onBlur(e) {
          return _this6.onBlur(e, 'start');
        },
        onFocus: getPreferredProp(this.props, 'onFocus', startFieldPath),
        placeholder: placeholder || dateFormat,
        name: "".concat(name, "-start"),
        disabled: disabled,
        type: "text",
        style: style.input
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "".concat(id, "-end"),
        className: "sr-only"
      }, "End Date"), /*#__PURE__*/React.createElement("input", {
        id: "".concat(id, "-end"),
        value: this.getInputValue('end'),
        onChange: function onChange(e) {
          return _this6.onInputChange(e, 'end');
        },
        onBlur: function onBlur(e) {
          return _this6.onBlur(e, 'end');
        },
        onFocus: getPreferredProp(this.props, 'onFocus', endFieldPath),
        placeholder: placeholder || dateFormat,
        name: "".concat(name, "-end"),
        disabled: disabled,
        type: "text",
        style: style.input
      })), /*#__PURE__*/React.createElement("div", {
        className: "ui-duration-field__controls"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "IconChevronLeft",
        onClick: this.onPreviousMonth
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, moment({
        month: this.state.month,
        year: this.state.year
      }).format('MMMM'), "\xA0"), /*#__PURE__*/React.createElement("label", {
        htmlFor: "".concat(id, "-start-year"),
        className: "sr-only"
      }, "Start Year"), /*#__PURE__*/React.createElement("input", {
        id: "".concat(id, "-start-year"),
        value: isNull(this.state.yearValue) ? this.state.year : this.state.yearValue,
        onChange: this.onEditYear
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, moment({
        month: nextMonth.month(),
        year: nextMonth.year()
      }).format('MMMM'), "\xA0"), /*#__PURE__*/React.createElement("label", {
        htmlFor: "".concat(id, "-end-year"),
        className: "sr-only"
      }, "End Year"), /*#__PURE__*/React.createElement("input", {
        id: "".concat(id, "-end-year"),
        value: isNull(this.state.yearValue) ? nextMonth.year() : this.state.yearValue,
        onChange: this.onEditYear
      })), /*#__PURE__*/React.createElement(Icon, {
        icon: "IconChevronRight",
        onClick: this.onNextMonth
      })), /*#__PURE__*/React.createElement("div", {
        className: "ui-duration-field__calendars"
      }, /*#__PURE__*/React.createElement(Calendar, {
        year: this.state.year,
        month: this.state.month,
        onDayClick: this.onDaySelect,
        dateRange: {
          start: this.state.startValue,
          end: this.state.endValue
        },
        isUtc: isUtc,
        shouldDisableDay: function shouldDisableDay(day) {
          return _shouldDisableDay(day, maxDate, minDate, shouldDisableDate);
        }
      }), /*#__PURE__*/React.createElement(Calendar, {
        year: nextMonth.year(),
        month: nextMonth.month(),
        onDayClick: function onDayClick(day) {
          return _this6.onDaySelect(day, true);
        },
        dateRange: {
          start: this.state.startValue,
          end: this.state.endValue
        },
        isUtc: isUtc,
        shouldDisableDay: function shouldDisableDay(day) {
          return _shouldDisableDay(day, maxDate, minDate, shouldDisableDate);
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "ui-form-field__hint",
        style: style.hint
      }, hint), /*#__PURE__*/React.createElement("div", {
        className: "ui-form-field__error",
        style: style.error
      }, getPreferredProp(this.props, 'error', startFieldPath), getPreferredProp(this.props, 'error', endFieldPath))));
    }
  }]);
}(Component);
DurationField.propTypes = {
  /** id for reference */
  id: PropTypes.string.isRequired,
  /** className for reference */
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  /** Override the inline-styles of the elements || **Not Recommended** */
  style: PropTypes.shape({
    container: PropTypes.object,
    dropdown: PropTypes.object,
    label: PropTypes.object,
    input: PropTypes.object,
    hint: PropTypes.object,
    error: PropTypes.object
  }),
  /** label text for button */
  label: PropTypes.string.isRequired,
  /** Input name */
  name: PropTypes.string,
  /** Should the label be displayed inline with the input? */
  inline: PropTypes.bool,
  /** Is the input disabled? */
  disabled: PropTypes.bool,
  /** Placeholder text */
  placeholder: PropTypes.string,
  /** Should the label be hidden? */
  hideLabel: PropTypes.bool,
  /** Help text displayed below the input */
  hint: PropTypes.node,
  /** Is the field required */
  required: PropTypes.bool,
  /** How the date should be formated in the input */
  dateFormat: PropTypes.string,
  /** String between the two Dates */
  separator: PropTypes.string,
  /**
   * Specify the value format you want
   * @param date:moment
   */
  valueFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** Should the component work with UTC moment? */
  isUtc: PropTypes.bool,
  /** Max permitted date */
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Min permitted date */
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Should this date be disabled?
   * @param date:moment
   */
  shouldDisableDate: PropTypes.func,
  /** See fieldProps doc */
  startField: PropTypes.object,
  /** See fieldProps doc */
  endField: PropTypes.object,
  /** Should the input use the mask according to the dateFormat? */
  useMask: PropTypes.bool,
  /** if the Field is on a different path than props.startField */
  startFieldPath: PropTypes.string,
  /** if the Field is on a different path than props.endField */
  endFieldPath: PropTypes.string
};
DurationField.defaultProps = {
  className: '',
  disabled: false,
  hideLabel: false,
  hint: '',
  inline: false,
  labelClassName: '',
  name: '',
  placeholder: '',
  required: false,
  style: {
    container: {},
    dropdown: {},
    label: {},
    input: {},
    hint: {},
    error: {}
  },
  dateFormat: 'MM/DD/YYYY',
  valueFormat: convertToUnixTimestamp,
  isUtc: true,
  maxDate: null,
  minDate: null,
  shouldDisableDate: function shouldDisableDate() {
    return false;
  },
  separator: '-',
  useMask: true,
  startField: {},
  endField: {},
  startFieldPath: 'startField',
  endFieldPath: 'endField'
};
export default DurationField;